/* eslint-disable import/first */
import React, { useState, useEffect } from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { useNavigate, useLocation } from '@reach/router';
import MobileHeader from '../../components/Header/MobileHeader';
import OrderModesBar from '../../components/OrderModesBar';
import LanguageButton from '../../components/LanguageButton';
import { FaArrowLeft } from '@react-icons/all-files/fa/FaArrowLeft';
import css from './index.module.scss';
const { selectCurrentCountry } = Slices.profileSlice;

const { selectOrderModeIdx } = Slices.configSlice;
import SavedAddress from '../../components/SavedAddress';
import { FormattedMessage } from 'react-intl';

function AddressList({ myAddress, isDesktop = false }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { action = '' } = location.state || {};
  const country = useSelector(selectCurrentCountry);
  const PageSelectedMode = useSelector((state) => selectOrderModeIdx(state, country, 'DELIVERY'));
  const auth = useSelector((state) => state.auth);
  const [showLogin, setShowLogin] = useState(false);

  useEffect(() => {
    if (auth.guestLogin) {
      setShowLogin(true);
      navigate();
    }
  }, [auth.guestLogin, navigate]);
  const onExitMemoized = React.useCallback((e) => navigate(-1), [navigate]);

  // if (showLogin) {
  //   // return (
  //   //   <div className={css.log}>
  //   //     <MobileHeader
  //   //       icon={<FaArrowLeft onClick={onExitMemoized} />}
  //   //       title={<FormattedMessage id="selectlocation" defaultMessage="Select Location" />}
  //   //       secondaryBar={<OrderModesBar action={action} defaultModeIdx={0} />}
  //   //       actionButtons={[<LanguageButton />]}
  //   //     />
  //   //     <NotLogged
  //   //       topbar={false}
  //   //       heading={<FormattedMessage id="no_address" defaultMessage="No Address" />}
  //   //       subHeading={
  //   //         <FormattedMessage
  //   //           id="login_view_addresses"
  //   //           defaultMessage="Login to view your added addresses"
  //   //         />
  //   //       }
  //   //       delivery={true}
  //   //     />
  //   //   </div>
  //   // );
  // }
  return (
    <div className={css.root}>
      {/* {!myAddress && (
        <MobileHeader
          icon={<FaArrowLeft onClick={onExitMemoized} />}
          title={<FormattedMessage id="selectlocation" defaultMessage="Select Location" />}
          secondaryBar={<OrderModesBar action={action} defaultModeIdx={0} />}
          actionButtons={[<LanguageButton />]}
        />
      )} */}
      {!isDesktop && !myAddress && (
        <MobileHeader
          icon={<FaArrowLeft onClick={onExitMemoized} />}
          title={<FormattedMessage id="selectlocation" defaultMessage="Select Location" />}
          secondaryBar={<OrderModesBar action={action} defaultModeIdx={PageSelectedMode} />}
          actionButtons={[<LanguageButton />]}
        />
      )}
      <main className={css.main}>
        <div className={css.section}>
          <div className={css.addressSection}>
            <SavedAddress action={action} setStatus showAction={true} myAddress={myAddress} />
          </div>
        </div>
      </main>
      <footer className={css.footer}></footer>
    </div>
  );
}

export default AddressList;
